import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'subject-list',
})

export default class SubjectsList extends Vue {

    @Prop()
    public subjectClassificationsList: any;

    @Prop()
    public valueId: any;


    public subjectList: any = [];

    private onSelectSubjectFacetsChild(subValue: any, valueId: any) {
        this.$set(subValue, 'isActive', subValue.isActive ? false : true);
        this.subjectList = this.subjectClassificationsList.filter((item: any) => {
            return item.isActive;
        }).map((items: any) => {
            return items.id;
        });
        this.$emit('onSelectSubjectFacets', subValue, valueId);
    }
}
